var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2286_2413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4377 32.8125C46.438 31.6262 46.7599 30.4621 47.369 29.4442C47.9782 28.4262 48.852 27.5924 49.8973 27.0315C50.9426 26.4706 52.1205 26.2035 53.3055 26.2587C54.4905 26.3138 55.6384 26.6892 56.6271 27.3449C57.6158 28.0005 58.4083 28.9119 58.9202 29.9821C59.4322 31.0522 59.6444 32.2412 59.5345 33.4224C59.4245 34.6036 58.9964 35.7329 58.2957 36.6902C57.595 37.6474 56.6479 38.3969 55.5552 38.8588C53.1752 39.865 49.9509 42.1269 48.9402 45.7713L48.8965 45.8019L11.3852 75.8144C6.54211 79.6906 9.28524 87.5 15.4846 87.5H90.5159C96.7196 87.5 99.4584 79.6906 94.6152 75.8144L58.6659 47.0575C58.7621 47.0094 58.8627 46.9613 58.9677 46.9175C61.5167 45.8388 63.7257 44.0895 65.3597 41.8554C66.9937 39.6214 67.9916 36.9862 68.2473 34.2302C68.5029 31.4742 68.0068 28.7005 66.8117 26.2039C65.6166 23.7074 63.7672 21.5815 61.4601 20.0523C59.1531 18.5232 56.4747 17.6479 53.7098 17.5196C50.945 17.3914 48.1971 18.0149 45.7583 19.3239C43.3196 20.6329 41.2813 22.5785 39.8602 24.9536C38.4391 27.3288 37.6883 30.0447 37.6877 32.8125C37.6877 33.9728 38.1487 35.0856 38.9691 35.9061C39.7896 36.7266 40.9024 37.1875 42.0627 37.1875C43.2231 37.1875 44.3359 36.7266 45.1563 35.9061C45.9768 35.0856 46.4377 33.9728 46.4377 32.8125ZM53.0002 53.725L84.2815 78.75H21.719L53.0002 53.725Z",
    fill: "#C8283B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2286_2413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 105,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanger);
export default __webpack_public_path__ + "static/media/hanger.a4fb2f1e500bfa5b57bc093f8d2575f6.svg";
export { ForwardRef as ReactComponent };